import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import type { ISingleInvoiceItem } from "../../type/exhibitorType";

const InvoiceItemTable = ({ data }: { data: ISingleInvoiceItem[] }) => {
	return (
		<TableContainer component={Paper} sx={{ mt: 3 }}>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>SL.</TableCell>
						<TableCell>Service Name</TableCell>
						<TableCell>Description</TableCell>
						<TableCell>Quantity</TableCell>
						<TableCell>Amount</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{data?.map((item, index) => (
						<TableRow key={item.id}>
							<TableCell>{index + 1}</TableCell>
							<TableCell>{item.product_name}</TableCell>
							<TableCell>{item.description}</TableCell>
							<TableCell>{item.quantity}</TableCell>
							<TableCell>{item.amount}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default InvoiceItemTable;
